module.exports = __webpack_public_path__ + "static/step-two@2x-9acc4b3d950271f4b35f46444083bba8.png";